<template>
  <div>
    <VAppBar app absolute elevation="0" dark class="header">
      <VContainer>
        <VRow align="center">
          <VCol cols="7">
            <a :href="`https://${HOME_DOMAIN}`" target="_blank" class="header-logo">
              <img
                src="../assets/img/logo.svg"
                :width="$vuetify.breakpoint.smAndUp ? 138 : 118"
              >
              <span class="logo-slogan d-none d-sm-block ml-4">
                {{ $t('slogan') }}
              </span>
            </a>
          </VCol>
          <VCol cols="5" class="text-right">
            <LanguageSelect />
          </VCol>
        </VRow>
      </VContainer>
    </VAppBar>
    <div class="skew-bg">
      <div class="skew-bg__content">
        <VMain>
          <RouterView />
        </VMain>
      </div>
    </div>
    <VFooter app absolute color="transparent" class="pa-0 align-end footer-company"
             min-height="168px"
    >
      <TheFooter />
    </VFooter>
    <PortalTarget name="support" />
  </div>
</template>

<script>
import { HOME_DOMAIN } from '@/helpers/constants';
import TheFooter from '../components/TheFooter.vue';
import LanguageSelect from '../components/LanguageSelect.vue';

export default {
  name: 'AppCompany',
  components: {
    TheFooter,
    LanguageSelect,
  },
  data() {
    return {
      subMenu: '',
      HOME_DOMAIN,
    };
  },
  computed: {
    companyId() {
      return this.$route.params.companyId || null;
    },
  },
};
</script>

<style lang="scss">
.header .v-toolbar__content {
  padding: 0 !important;
}
</style>

<style scoped lang="scss">
.skew-bg {
  position: relative;
  overflow: hidden;
  min-height: 100vh;
  background: map-get($grey, 'lighten-4');
  &__content {
    position: relative;
    z-index: 1;
  }
}
.header {
  background: linear-gradient(90deg, #0a82d9 0%, #00cbf3 100%);
  z-index: 9 !important;
  box-sizing: border-box;
  &__link {
    font-size: 16px;
    color: #fff;
    font-weight: 500;
    text-decoration: none;
  }

  a {
    text-decoration: none !important;
  }

  &::before {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: url(../assets/img/header/bg.png) no-repeat right;
    background-size: cover;
  }
}
.submenu {
  position: absolute;
  top: 100%;
  left: 0;
  background: #2a75e5;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  &:before {
    content: '';
    bottom: 100%;
    right: 30px;
    border: 10px solid transparent;
    border-bottom-color: #2a75e5;
    position: absolute;
    z-index: 5555;
  }
}
.header-logo {
  display: flex;
  align-items: center;
}
.logo-slogan {
  font-size: 0.75rem;
  color: #ffffff;
  text-decoration: none !important;
  font-weight: 500;
  line-height: 1.17;
  max-width: 170px;
}
.v-footer--absolute.footer-company {
  z-index: 1;
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .logo-slogan {
    font-size: 0.625rem;
    line-height: 1.2;
    max-width: 9.25rem
  }
  .header::before {
    background-image: url(../assets/img/header/bg-mobile.png);
  }
}

@media #{map-get($display-breakpoints, 'sm-and-up')} {
  .header {
    &__link {
      margin-left: $spacer * 10;
    }
  }
  .submenu {
    position: relative;
    top: 0;
    display: block;
    background: transparent;
    &:before {
      display: none;
    }
  }
}
</style>

<i18n locale="en" lang="yaml">
  slogan: The first automated interview service with a real person
</i18n>

<i18n locale="ru" lang="yaml">
  slogan: Сервис видеособеседований с человеческим лицом
</i18n>
